import { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(ScrollTrigger);

export default function AnimateOnScroll({ children, animation = "fade-up" }) {
  const container = useRef();

  useGSAP(() => {
    const elements = container.current.querySelectorAll("[data-animate]");

    elements.forEach((el) => {
      const animType = el.dataset.animate;

      if (animType === "fade-up") {
        gsap.fromTo(
          el,
          { opacity: 0, y: 30 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 90%",
              toggleActions: "play none none none",
            },
          }
        );
      }

      // Add more animations here if needed
    });
  }, []);

  return <div ref={container}>{children}</div>;
}
